import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Testimonials from "./components/Testimonials";
import Blog from "./components/Blog";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import HeatPumpRequest from "./components/HeatPumpRequest";
import CityPage from "./components/CityPage";
import RegionsPage from "./components/RegionsPage";
import RegionalPresence from "./components/RegionalPresence";
import ImpressumPage from "./components/ImpressumPage";
import DatenschutzPage from "./components/DatenschutzPage";
import AGBPage from "./components/AGBPage";
import WiderrufsPage from "./components/WiderrufsPage";
import FloatingButtons from "./components/FloatingButtons";
import { Toaster } from "./components/ui/toaster";

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <About />
    <Services />
    <RegionalPresence />
    <Projects />
    <Testimonials />
    <Blog />
    <FAQ />
    <Contact />
    <Footer />
    <FloatingButtons />
    <Toaster />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/regionen" element={<><Header /><RegionsPage /><Footer /><FloatingButtons /><Toaster /></>} />
          <Route path="/waermepumpe" element={<><HeatPumpRequest /><FloatingButtons /><Toaster /></>} />
          <Route path="/impressum" element={<><ImpressumPage /><FloatingButtons /><Toaster /></>} />
          <Route path="/datenschutz" element={<><DatenschutzPage /><FloatingButtons /><Toaster /></>} />
          <Route path="/agb" element={<><AGBPage /><FloatingButtons /><Toaster /></>} />
          <Route path="/widerruf" element={<><WiderrufsPage /><FloatingButtons /><Toaster /></>} />
          <Route path="/:citySlug" element={<><Header /><CityPage /><Footer /><FloatingButtons /><Toaster /></>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;